import { useState, useEffect } from 'react';
import { configs } from '@constants/configs/configs';

import { localStorageHyperDashboardTools } from '@utils/tools/localStorageHyperDashboardTools';

export const useGodMode = () => {

    const path = window.location.origin;

    const isShownDueToSettings = localStorageHyperDashboardTools.getValueByPropName('isHyperDashboardShown', false);

    const [isHyperNavigatorShown, switchHyperNavigation] = useState(isShownDueToSettings);
    const [ isHyperNavigationAvailable, switchHyperNavigationAvailability ] = useState(false);


    const codes = [
        {
            code: 16,
            type: 'isShift'
        },
        {
            code: 17,
            type: 'isCtrl'
        },
        {
            code: 81,
            type: 'isQ'
        }
    ];

    const [ keys, setKeys ] = useState(Object.assign(
        {},
        ...codes.map(code => ({
            [code.type]: false
        }))
    ));

    const eligiblePaths = [
        'eng.vimo.com',
        'ghixqa.com',
        'localhost:8888',
        'localhost:7777',
        'localhost:8080'
    ];

    useEffect(() => {
        if(configs.ENV.DEVELOPMENT) {
            !isHyperNavigationAvailable && switchHyperNavigationAvailability(!isHyperNavigationAvailable);
            return undefined;
        }
        if(path && eligiblePaths.some(p => path.includes(p))) {
            !isHyperNavigationAvailable && switchHyperNavigationAvailability(!isHyperNavigationAvailable);
        }
    }, [ ] );

    useEffect(() => {
        document.onkeydown = keyDownEvent;
        document.onkeyup = keyUpEvent;

        const updateKeys = (type, value) => {
            setKeys(keys => ({
                ...keys,
                [type]: value
            }));
        };

        function keyDownEvent() {
            const isNeededCode = codes.find(code => code.code === event.keyCode);
            if(isNeededCode) {
                updateKeys(isNeededCode.type, true);
            }
        }

        function keyUpEvent() {
            const isNeededCode = codes.find(code => code.code === event.keyCode);
            if(isNeededCode) {
                updateKeys(isNeededCode.type, false);
            }

            if(Object.values(keys).every(key => key)) {
                switchHyperNavigation(!isHyperNavigatorShown);
            }
        }
    });

    return isHyperNavigationAvailable && isHyperNavigatorShown;
};
